import api from './api'

export default class DeleteRequest {
  url: string

  headers: any = {}
  timeout: number | undefined

  constructor(url: string, headers: any, timeout?: number) {
    this.url = url
    this.headers = headers
    this.timeout = timeout
  }

  async run() {
    const headers = { ...this.headers }
    return api.delete(this.url, { headers, timeout: this.timeout })
  }
}
